module.exports = __webpack_public_path__ + "static/CommunitySeekingCover-43655904d99348a9c812981da5c952df.jpg";